import { render, staticRenderFns } from "./MasterCampaignSms.vue?vue&type=template&id=227e1353&"
import script from "./MasterCampaignSms.vue?vue&type=script&lang=js&"
export * from "./MasterCampaignSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports